import { Component, OnInit } from '@angular/core';
import { GridviewComponent } from '../gridview/gridview.component';
import { ToastrService } from 'ngx-toastr';
import {LoginService} from '../login.service';

@Component({
  selector: 'app-notices',
  templateUrl: './notices.component.html',
  styleUrls: ['./notices.component.css']
})
export class NoticesComponent implements OnInit {
  private gridApi;
  private gridColumnApi;
  public context;
  public frameworkComponents;
  defaultColDef = { resizable: true, cellStyle:{'font-size':'14px'} };
  tabToNextCell:any;
  columnDefs = [
    {headerName: 'Document ID', field: 'id' },
    {headerName: 'Notice Type', field: 'description' },
    {headerName: 'Generated Date', field: 'generated_dt'},
    {headerName: 'Action', field: 'file_location',cellRenderer:'viewrenderer', sortable: false}
];

rowData = [];

  constructor(public loginService:LoginService, public toastService: ToastrService) { }

  ngOnInit() {
    this.context = {
      componentParent:this
    };
    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellPosition;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
      return;
      } else {
      return nextCell;
      }
      }; 
    this.frameworkComponents = {
      viewrenderer: GridviewComponent
    };
    this.load();
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    //this.gridApi.setDomLayout("autoHeight");
  }
  load(){
    let request = {
      perId:this.loginService.personId,
      type:'NT'
    };
    this.loginService.loadDocuments(request).subscribe((data:Array<Object>)=>{
      data.forEach((element)=>{
        element['generated_dt'] = element['generated_dt'].split('T')[0];
        element['generated_dt'] = element['generated_dt'].split('-')[1] + '/' + element['generated_dt'].split('-')[2] + '/' + element['generated_dt'].split('-')[0];
      })
      this.rowData = data;
    },error=>{
      this.toastService.error("Unable to load files", "My Documents");
    })
  }
  focus(event){
    if(event.keyCode == 9){
      this.gridApi.ensureIndexVisible(0);
      let firstCol = this.gridColumnApi.getAllDisplayedColumns()[0];
      this.gridApi.ensureColumnVisible(firstCol);
      if(firstCol.gridOptionsWrapper.gridOptions.rowData.length == 0){
        return;
      }
      else{
        event.preventDefault();
        this.gridApi.setFocusedCell(0, firstCol);
      }
    }
    else{
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/notices/notices.component.ts